<template>
  <div class="examInfo-card">
    <div class="left">
      <div class="img-box">
        <img :src="content.picture_url">
      </div>
      <div class="info-box">
        <div class="text-header">
          <div class="tags">
          </div>
          <!-- <span class="subject-type">统考科目</span> -->
          <span class="subject-name">{{content.name}}</span>
        </div>
        <p class="title">{{content.description}}</p>
        <p class="old-price">¥{{content.market_price}}</p>
        <div class="text-footer">
          <span class="new-price">¥{{content.price}}</span>
        </div>
      </div>
      <!-- <div class="text-box">
        注意：此题库仅适用于  内蒙古大学 汉语文学专业
      </div> -->
    </div>
    <div class="right">
      <div class="button-wrap">
        <!-- <div class="synchron"
             @click="handleSync2()"
             v-if="content&&content.pack_note_id==null">
          <img src="https://upload.kaoyanbox.net/7eed70aeba04983a6fba0508422fd9a1.png" />
          <span>同步笔记2</span>
        </div> -->
        <el-button @click="handleSync2()"
                   type="primary"
                   v-if="content && content.pack_note_id == null"
                   :disabled="content&&content.create_source_note_id"
                   style="height: 32px;margin-right: 10px;">
          <div style="display: flex;align-items: center;">
            <img src="https://upload.kaoyanbox.net/7eed70aeba04983a6fba0508422fd9a1.png"
                 style="widht:12px;height:12px;" />
            <span>同步笔记2</span>
          </div>
        </el-button>
        <div class="synchron"
             @click="handleLookSync2()"
             v-if="content&&content.pack_note_id !=null">
          <img src="https://upload.kaoyanbox.net/7eed70aeba04983a6fba0508422fd9a1.png" />
          <span>查看笔记2</span>
        </div>
        <!-- <div class="synchron"
             @click="handleSync()"
             v-if="content&&content.create_source_note_id==null">
          <img src="https://upload.kaoyanbox.net/7eed70aeba04983a6fba0508422fd9a1.png" />
          <span>同步笔记</span>
        </div> -->
        <el-button @click="handleSync()"
                   type="primary"
                   v-if="content && content.create_source_note_id == null"
                   :disabled="content&&content.pack_note_id !=null"
                   style="height: 32px;margin-right: 10px;">
          <div style="display: flex;align-items: center;">
            <img src="https://upload.kaoyanbox.net/7eed70aeba04983a6fba0508422fd9a1.png"
                 style="widht:12px;height:12px;" />
            <span>同步笔记</span>
          </div>

        </el-button>
        <div class="synchron"
             @click="handleLookSync()"
             v-if="content&&content.create_source_note_id !=null">
          <img src="https://upload.kaoyanbox.net/7eed70aeba04983a6fba0508422fd9a1.png" />
          <span>查看笔记</span>
        </div>
        <router-link :to="`/read/edit/${content.id}`">
          <el-button type="primary">编辑基本信息</el-button>
        </router-link>
      </div>
      <div class="text-wrap">
        <div class="exam-num">
          <p>{{content.item_count || 0}}</p>
          <span>总题数</span>
        </div>
        <div class="member-num">
          <p>{{content.user_count || 0}}位</p>
          <span>研友在学</span>
        </div>
        <div>
          <p>100道</p>
          <span>研究收藏题目</span>
        </div>
      </div>
    </div>

    <SycNote :isVisible="noteVisible"
             @close="close"
             :title="title"
             :product_ids="content.id" />
    <SycNote :isVisible="noteVisible2"
             @close="close2"
             :title="title2"
             :product_ids="content.id" />
    <DetailLookSync :isVisible="lookDetailVisible"
                    @close="lookDetailClose"
                    :noteId="content.create_source_note_id" />
    <DetailLookSync :isVisible="lookDetailVisible2"
                    @close="lookDetailClose2"
                    :noteId="content.pack_note_id" />
  </div>
</template>

<script>
import SycNote from '@/components/dialog/syncNote'
import DetailLookSync from '@/components/dialog/DetailLookSync'
export default {
  components: {
    SycNote,
    DetailLookSync,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      title: '同步笔记',
      noteVisible: false,
      title2: '同步笔记2',
      noteVisible2: false,
      lookDetailVisible: false,
      lookDetailVisible2: false,
    }
  },
  methods: {
    handleSync() {
      this.noteVisible = true
    },
    handleSync2() {
      this.noteVisible2 = true
    },
    handleLookSync() {
      this.lookDetailVisible = true
      console.log('this.lookDetailVisible', this.lookDetailVisible)
    },
    handleLookSync2() {
      this.lookDetailVisible2 = true
    },
    close() {
      this.noteVisible = false
      this.$emit('refurse')
    },
    close2() {
      this.noteVisible2 = false
      this.$emit('refurse')
    },
    lookDetailClose() {
      this.lookDetailVisible = false
    },
    lookDetailClose2() {
      this.lookDetailVisible2 = false
    },
  },
}
</script>

<style lang="less" scoped>
.examInfo-card {
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 20px;
  overflow: hidden;

  display: flex;
  justify-content: space-between;

  .left {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    flex: 1;

    .img-box {
      margin-right: 15px;
    }
    img {
      width: 94px;
      height: 94px;
      object-fit: cover;
    }
    .text-box {
      width: 100%;
      margin-top: 10px;
    }
    .text-header {
      display: flex;
      margin-bottom: 10px;
    }
    .tag {
      font-size: 12px;
      color: #fff;
      background: #0091ff;
      border-radius: 5px;
      padding: 2px 5px;
      margin-right: 10px;
    }
    .subject-type {
      font-weight: bold;
      margin-right: 10px;
    }
    .subject-name {
      font-weight: bold;
      font-size: 18px;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 400px;
    }
    .old-price {
      font-weight: bold;
      color: #999;
      text-decoration: line-through;
    }
    .new-price {
      font-weight: bold;
      color: #ff6600;
    }
    .member-price {
      font-size: 12px;
      color: #fff;
      padding: 2px 10px;
      background: #0091ff;
      border-radius: 5px;
      margin-left: 5px;
    }
    .text-footer {
      margin-top: 5px;
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    flex: 1;

    .button-wrap {
      display: flex;
      justify-content: flex-end;
      width: 100%;

      .synchron {
        cursor: pointer;
        margin-right: 10px;
        text-align: center;
        justify-content: center;
        width: 80px;
        font-size: 12px;
        height: 32px;
        line-height: 32px;
        background: #409eff;
        color: #fff;
        border-radius: 2px 2px 2px 2px;
        display: flex;
        align-items: center;
        img {
          margin-right: 1px;
          width: 12px;
          height: 12.61px;
        }
      }
    }
    .text-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      & > div {
        text-align: center;
        padding: 0 30px;
      }
    }

    .member-num {
      border: 1px solid #ccc;
      border-width: 0 1px;
    }

    p {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}
</style>
